<template>
  <div class="w-full h-full overflow-y-auto" v-loading="pageLoading">
    <div class="flex justify-start item-start mt-10px">
      <img src="../../../assets/images/titleIcon.png" alt="" />
      <span class="text-16px text-white custom-shadow ml-4px"> 基本信息 </span>
    </div>
    <div class="w-full text-14px flex leading-40px" v-for="item in baseFields" :key="item.field">
      <div class="text-[#ffffff99] w-90px text-right">{{ item.name }}：</div>
      <el-tooltip effect="dark" :content="detailInfo[item.field]" placement="top">
        <div
          class="text-white w-[calc(100%-80px)]"
          :class="
            ['description', 'rectificationMeasure'].includes(item.field)
              ? 'text-overflow'
              : 'truncate'
          "
        >
          {{ detailInfo[item.field] }}
        </div>
      </el-tooltip>
    </div>
    <div class="flex justify-start item-start mb-10px mt-10px" v-if="detailInfo.remarks.length">
      <img src="../../../assets/images/titleIcon.png" alt="" />
      <span class="text-16px text-white custom-shadow ml-4px"> 整改情况 </span>
    </div>
    <el-collapse v-model="collapseActiveName" accordion>
      <el-collapse-item
        v-for="item in detailInfo.remarks"
        :title="item.rectificationDate"
        :name="item.remarkId"
        :key="item.remarkId"
      >
        <div class="w-full text-14px flex leading-40px" v-for="el in remarkFields" :key="el.field">
          <div class="text-[#ffffff99] w-120px text-right">{{ el.name }}：</div>
          <el-tooltip effect="dark" :content="item[el.field]" placement="top">
            <div
              v-if="el.field !== 'filePathStr'"
              class="text-white w-[calc(100%-80px)]"
              :class="
                ['description', 'acceptanceOpinion'].includes(el.field)
                  ? 'text-overflow'
                  : 'truncate'
              "
            >
              {{ item[el.field] }}
            </div>
          </el-tooltip>
          <div v-if="el.field === 'filePathStr'" class="w-[calc(100%-80px)] flex flex-wrap">
            <el-image
              v-for="img in item.filePathStr.split(',')"
              :key="img"
              class="w-50px h-50px mr-10px"
              :src="img"
              :preview-src-list="[img]"
              fit="fill"
            ></el-image>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { SafetyQualityApi } from '@wiz-api/haiguang'

const safetyQualityApi = new SafetyQualityApi()
export default {
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      collapseActiveName: '',
      pageLoading: false,
      detailInfo: {},
      baseFields: [
        {
          name: '项目名称',
          field: 'projectName',
        },
        {
          name: '主题',
          field: 'subject',
        },
        {
          name: '类型',
          field: 'type',
        },
        {
          name: '存在问题',
          field: 'description',
        },
        {
          name: '整改负责人',
          field: 'rectificationUserName',
        },
        {
          name: '整改期限',
          field: 'rectificationDeadline',
        },
        {
          name: '整改措施',
          field: 'rectificationMeasure',
        },
      ],
      remarkFields: [
        {
          name: '完成情况描述',
          field: 'description',
        },
        {
          name: '整改人',
          field: 'rectificationUserName',
        },
        {
          name: '整改后图片',
          field: 'filePathStr',
        },
        {
          name: '验收人',
          field: 'acceptorName',
        },
        {
          name: '验收意见',
          field: 'acceptanceOpinion',
        },
      ],
    }
  },
  watch: {
    'transferProps.problemId': {
      handler(val) {
        if (val) {
          this.getProblemDetail()
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.transferProps?.problemId) {
      this.getProblemDetail()
    }
  },
  methods: {
    async getProblemDetail() {
      this.pageLoading = true
      const [err, res] = await safetyQualityApi.getSafetyQualityVisualProblemDetail({
        problemId: this.transferProps.problemId,
      })
      this.pageLoading = false
      if (!err) {
        console.log(res)
        this.detailInfo = res
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.text-overflow {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

::v-deep .el-collapse {
  border: none !important;
  border-radius: 5px;

  &-item__header {
    color: #fff !important;
    background-color: #0f6b73 !important;
    border: none !important;
    border-radius: 5px;
  }

  &-item__wrap {
    color: #fff !important;
    background-color: transparent !important;
    border: none !important;
  }

  &-item__content {
    padding: 0 10px !important;
    color: #fff !important;
  }
}
</style>
